module.exports = __webpack_public_path__ + "static/img/test3.d055432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test3.jpg
// module id = a5rD
// module chunks = 13